/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_Created_OnceInputs */

const cs_import_tokens_created_once = /** @type {(inputs: Import_Tokens_Created_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkopírujte token teď — znovu se nezobrazí.`)
};

const en_import_tokens_created_once = /** @type {(inputs: Import_Tokens_Created_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy this token now — it will not be shown again.`)
};

/**
* | output |
* | --- |
* | "Copy this token now — it will not be shown again." |
*
* @param {Import_Tokens_Created_OnceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_created_once = /** @type {((inputs?: Import_Tokens_Created_OnceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_Created_OnceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_created_once(inputs)
	return cs_import_tokens_created_once(inputs)
});